import {
	isAndroid,
	isIOS,
	isWindows,
	isMacOs,
	osName
} from "react-device-detect";

export const getPlatform = (): string => {
	// SSR / non-browser safety
	if (typeof navigator === "undefined") {
		return "unknown";
	}

	// Prefer react-device-detect, which already includes the iPadOS hack (MacIntel + touch)
	if (isIOS) {
		return "ios";
	}
	if (isAndroid) {
		return "android";
	}
	if (isWindows) {
		return "windows";
	}
	if (isMacOs) {
		return "macos";
	}

	// Linux (osName or userAgent contains "linux")
	const ua = (navigator.userAgent || "").toLowerCase();
	if (osName?.toLowerCase() === "linux" || ua.includes("linux")) {
		return "linux";
	}

	return "unknown";
};
